import Links from '@/shared/constants/navegacao';
import { Link } from 'react-router-dom';

export default function AuditoriasIndexPage() {
  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-4">Auditorias</h3>
        <span className="blockquote-footer pb-4 text-end">Selecione o tipo de log para consulta.</span>
      </div>
      <hr />

      <div className="col-12 d-flex gap-2">
        <Link to={Links.Auditorias_LogsUso} className="btn btn-outline-primary">
          Logs de Uso
        </Link>
        <Link to={Links.Auditorias_LogsEmails} className="btn btn-outline-primary">
          Logs de E-mails
        </Link>
        <Link to={Links.Auditorias_LogsTasks} className="btn btn-outline-primary">
          Logs de Tarefas
        </Link>
        <Link to={Links.Auditorias_RateLimit} className="btn btn-outline-primary">
          Rate Limit
        </Link>
      </div>
    </div>
  );
}

